module.exports = __webpack_public_path__ + "media/icons-detail.3911b0fe.webm";